/**
 * Props making an element act as a button from the keyboard, reached by Tab
 * and pressed by Enter or Space, where a <button> would take on styles not
 * meant for it (the header's, or a page's around the Web Reader). Works on
 * SVG too, which has no click() of its own.
 */
export const props = {
  role: "button" as const,
  // Lowercase, as SVG's attributes are case-sensitive
  tabindex: 0,
  onKeyDown: (event: KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.currentTarget?.dispatchEvent(
        new MouseEvent("click", { bubbles: true, cancelable: true })
      );
    }
  },
};
